import _ from 'lodash';
import {
    BIO_SEARCH_TYPE,
    ABST_NUC,
    ABST_PROTEIN,
    SEQUENCE_TYPE,
} from '../../../constants';

export const tranformSequencePosition = function(position, nos, $t) {
    let positionStrArrs = [];
    if (nos.length) {
        positionStrArrs.push(`SEQ ID. ${nos.join(', ')}`);
    }
    const table = _.get(position, 'TABLE', []);
    if (table.length) {
        positionStrArrs.push(`${$t('bio.position.TABLE')} ${table.join(', ')}`);
    }
    const fig = _.get(position, 'FIG', []);
    if (fig.length) {
        positionStrArrs.push(`${$t('bio.position.FIG')} ${fig.join(', ')}`);
    }
    const page = _.get(position, 'PAGE', []);
    if (page.length) {
        positionStrArrs.push(`${$t('bio.position.PAGE')} ${page.join(', ')}`);
    }
    const paragraph = _.get(position, 'PARAGRAPH', []);
    if (paragraph.length) {
        positionStrArrs.push(`${$t('bio.position.PARAGRAPH')} ${paragraph.join(', ')}`);
    }
    const other = _.get(position, 'OTHER', []);
    if (other.length) {
        positionStrArrs.push(`${$t('bio.position.OTHER')} ${other.join(', ')}`);
    }
    const example = _.get(position, 'EXAMPLE', []);
    if (example.length) {
        positionStrArrs.push(`${$t('bio.position.EXAMPLE')} ${example.join(', ')}`);
    }
    const app = _.get(position, 'APP', []);
    if (app.length) {
        positionStrArrs.push(`${$t('bio.position.APP')} ${app.join(', ')}`);
    }
    const annex = _.get(position, 'ANNEX', []);
    if (annex.length) {
        positionStrArrs.push(`${$t('bio.position.ANNEX')} ${annex.join(', ')}`);
    }
    return positionStrArrs;
};

export const transformHits = (record) => {
    if (!_.isEmpty(record.cdr_hit)) {
        return record.cdr_hit
            .map(cdr => {
                const cdrKey = parseInt(cdr.label.slice(-1));
                if (cdr) {
                    return {
                        cdr: cdrKey,
                        queryLabel: cdr.label,
                        matched: cdr.matched,
                        queryStart: cdr.q_start,
                        queryEnd: cdr.q_end,
                        queryString: cdr.q_string,
                        subjectStart: cdr.s_start,
                        subjectEnd: cdr.s_end,
                        subjectString: cdr.s_string,
                        similarityValue: _.get(cdr, 'identity_value'),
                        fragmentIndex: undefined,
                    };
                }
                return {
                    cdr: cdrKey,
                    queryLabel: `CDR${cdrKey}`,
                    matched: '',
                    queryStart: 1,
                    queryEnd: cdr.sequence.length,
                    queryString: cdr.sequence,
                    subjectStart: 0,
                    subjectEnd: 0,
                    subjectString: '',
                    similarityValue: _.get(cdr, 'identity_value'),
                    fragmentIndex: undefined,
                };
            });
    }
    if (!_.isEmpty(record.fragment_hit)) {
        return record.fragment_hit
            .map(x => {
                return {
                    cdr: undefined,
                    queryLabel: `F${x.label}`,
                    matched: x.matched,
                    queryStart: x.q_start,
                    queryEnd: x.q_end,
                    queryString: x.q_string,
                    subjectStart: x.s_start,
                    subjectEnd: x.s_end,
                    subjectString: x.s_string,
                    similarityValue: _.get(x, 'identity_value'),
                    fragmentIndex: x.label,
                };
            })
            .sort((x, y) => x.fragmentIndex - y.fragmentIndex);
    }
    return [
        {
            matched: _.get(record, 'matched'),
            queryStart: _.get(record, 'q_start'),
            queryEnd: _.get(record, 'q_end'),
            queryString: _.get(record, 'q_string'),
            subjectStart: _.get(record, 's_start'),
            subjectEnd: _.get(record, 's_end'),
            subjectString: _.get(record, 's_string'),
            similarityValue: _.get(record, 'identity_value') || 1.0,
            cdr: undefined,
            queryLabel: undefined,
            fragmentIndex: undefined,
        },
    ];
};


/**
 *  组装查询序列参数
 * @param {查询类型} searchType
 * @param {bio带过来的查询序列} querySequence
 * @param {勾选的序列，从bio带过来的} selectedSequence
 * @param {是不是上传的序列} isUpload
 * @param {上传的序列} uploadSequence
 * @param {序列的labelKey，在antibody，fragment等query包含子序列的场景用来区分子序列} targetLabelKey
 * @param {antibody的mismatch设置} mismatches
 * @returns
 */
export function generateSequenceList(searchType, querySequence, selectedSequence, isUpload, uploadSequence, targetLabelKey, mismatches) {
    if (isUpload) {
        return [
            {
                label: uploadSequence.label,
                sequence: uploadSequence.sequence,
                mismatch: '',
                sequence_id: '',
            },
        ];
    }
    if (selectedSequence) {
        return [
            {
                label: '',
                sequence: selectedSequence.sequence,
                mismatch: '',
                sequence_id: selectedSequence.seqId,
            },
        ];
    }
    let sequenceList = [];
    let labelKey;
    let targetQuery;
    let prefixLabel;
    let queryField;
    let prefixNum;
    let currentQuery;
    switch (searchType) {
        case BIO_SEARCH_TYPE.motif:
        case BIO_SEARCH_TYPE.motif2:
        case BIO_SEARCH_TYPE.sequence:
        case BIO_SEARCH_TYPE.degenerate:
        case BIO_SEARCH_TYPE.short:
            sequenceList = [
                {
                    label: _.get(querySequence, 'manual_sequence.label', ''),
                    sequence: _.get(querySequence, 'manual_sequence.sequence', ''),
                    mismatch: '',
                    sequence_id: '',
                },
            ];
            break;
        case BIO_SEARCH_TYPE.combined:
            currentQuery = querySequence.combined_sequence.find(item => item.label === targetLabelKey);
            sequenceList = [
                {
                    label: _.get(currentQuery, 'label', ''),
                    sequence: _.get(currentQuery, 'sequence', ''),
                    mismatch: '',
                    sequence_id: '',
                },
            ];
            break;
        case BIO_SEARCH_TYPE.cdr:
        case BIO_SEARCH_TYPE.antibody:
            queryField = searchType === BIO_SEARCH_TYPE.cdr ? 'cdr_sequence' : 'antibody_sequence';
            prefixNum = searchType === BIO_SEARCH_TYPE.cdr ? 3 : 5;
            labelKey = targetLabelKey;
            if (labelKey.indexOf('CDR1+2+3') > -1) {
                prefixLabel = labelKey.substr(0, prefixNum);
                sequenceList = _.get(querySequence, queryField).filter(x => x.label.indexOf(prefixLabel) > -1 && x.label !== labelKey).map(x => {
                    return {
                        label: _.get(x, 'label', ''),
                        sequence: _.get(x, 'sequence', ''),
                        mismatch: _.get(mismatches && mismatches.find(m => x.label.indexOf(m.label) > -1), 'value'),
                        sequence_id: '',
                    };
                });
            } else {
                targetQuery = _.get(querySequence, queryField).find(x => labelKey === x.label);
                if (targetQuery) {
                    sequenceList = [
                        {
                            label: _.get(targetQuery, 'label', ''),
                            sequence: _.get(targetQuery, 'sequence', ''),
                            mismatch: _.get(mismatches && mismatches.find(m => targetQuery.label.indexOf(m.label) > -1), 'value'),
                            sequence_id: '',
                        },
                    ];
                }
            }
            break;
        case BIO_SEARCH_TYPE.fragmentSize:
            sequenceList = [
                {
                    label: _.get(querySequence, 'fragment_length_sequence.label', ''),
                    sequence: _.get(querySequence, 'fragment_length_sequence.sequence', ''),
                    mismatch: '',
                    sequence_id: '',
                },
            ];
            break;
        case BIO_SEARCH_TYPE.fragmentMulti:
            // fragment_multi_sequence  fragment_multi
            labelKey = targetLabelKey;
            if (labelKey === `Fragment${_.get(querySequence.fragment_multi_sequence.fragment_multi, '[0].fragment_all')}`) {
                sequenceList = querySequence.fragment_multi_sequence.fragment_multi
                    .filter(x => !x.fragment_all)
                    .map(f => {
                        return {
                            label: _.get(f, 'fragment_index', ''),
                            sequence: _.get(f, 'fragment_sequence', ''),
                            mismatch: '',
                            sequence_id: '',
                        };
                    });
            } else {
                const currentIndex = _.toNumber(labelKey.replace('Fragment', ''));
                const targetQuery = querySequence.fragment_multi_sequence.fragment_multi.find(x => x.fragment_index === currentIndex);
                if (targetQuery) {
                    sequenceList = [
                        {
                            label: _.get(targetQuery, 'fragment_position', ''),
                            sequence: _.get(targetQuery, 'fragment_sequence', ''),
                            mismatch: '',
                            sequence_id: '',
                        },
                    ];
                }
            }
            break;
    }
    return sequenceList;
}

export function generateQuerySequenceDropDownSet(bioQuerySequences) {
    let r = [];
    if (bioQuerySequences) {
        // antibody cdr fragment 需要分组标签
        let key = 0;
        bioQuerySequences.forEach(v => {
            let groupLabel = '';
            if (v.type === BIO_SEARCH_TYPE.fragmentMulti ||
                v.type === BIO_SEARCH_TYPE.cdr ||
                v.type === BIO_SEARCH_TYPE.antibody ||
                v.type === BIO_SEARCH_TYPE.combined) {
                groupLabel = `Query: ${v.search_name}`;
            }
            switch (v.type) {
                case BIO_SEARCH_TYPE.sequence:
                case BIO_SEARCH_TYPE.degenerate:
                case BIO_SEARCH_TYPE.short:
                case BIO_SEARCH_TYPE.motif:
                case BIO_SEARCH_TYPE.motif2:
                    r.push({
                        label: groupLabel,
                        data: [{
                            key: ++key,
                            label: `Query: ${v.search_name}`,
                            value: v.manual_sequence.sequence,
                            bioUk: v.bio_uk,
                            type: v.type,
                        }],
                    });
                    break;
                case BIO_SEARCH_TYPE.modification:
                    // eslint-disable-next-line
                    const manualSequence = _.get(v, 'manual_sequence.sequence');
                    if (manualSequence) {
                        r.push({
                            label: groupLabel,
                            data: [{
                                key: ++key,
                                label: `Query: ${v.search_name}`,
                                value: manualSequence,
                                bioUk: v.bio_uk,
                                type: v.type,
                            }],
                        });
                    }
                    break;
                case BIO_SEARCH_TYPE.fragmentSize:
                    r.push({
                        label: groupLabel,
                        data: [{
                            key: ++key,
                            label: `Query: ${v.search_name}`,
                            value: v.fragment_length_sequence.sequence,
                            bioUk: v.bio_uk,
                            type: v.type,
                        }],
                    });
                    break;
                case BIO_SEARCH_TYPE.fragmentMulti:
                    r.push({
                        label: groupLabel,
                        data: v.fragment_multi_sequence.fragment_multi.map(x => ({
                            key: ++key,
                            label: x.fragment_all ? `Fragment${x.fragment_all}` : `Fragment${x.fragment_index}: ${x.fragment_position}`,
                            value: x.fragment_sequence,
                            bioUk: v.bio_uk,
                            labelKey: `Fragment${x.fragment_all || x.fragment_index}`,
                            type: v.type,
                        })),
                    });
                    break;
                case BIO_SEARCH_TYPE.antibody:
                    r.push({
                        label: groupLabel,
                        data: v.antibody_sequence.map(x => ({
                            key: ++key,
                            label: x.label_display ? `${x.label_display}: ${x.sequence}` : `${x.label}: ${x.sequence}`,
                            value: x.sequence,
                            bioUk: v.bio_uk,
                            labelKey: x.label,
                            labelType: x.label_type,
                            type: v.type,
                        })),
                    });
                    break;
                case BIO_SEARCH_TYPE.cdr:
                    r.push({
                        label: groupLabel,
                        data: v.cdr_sequence.map(x => ({
                            key: ++key,
                            label: `${x.label}: ${x.sequence}`,
                            value: x.sequence,
                            bioUk: v.bio_uk,
                            labelKey: x.label,
                            type: v.type,
                        })),
                    });
                    break;
                case BIO_SEARCH_TYPE.combined:
                    r.push({
                        label: groupLabel,
                        data: v.combined_sequence.map(x => ({
                            key: ++key,
                            label: `${x.label}: ${x.sequence}`,
                            value: x.sequence,
                            bioUk: v.bio_uk,
                            labelKey: x.label,
                            type: v.type,
                        })),
                    });
                    break;
            }
        });
    }
    return r;
}

function transformBaseBlastParams({ algorithmSettings, dbType, sequenceType }, searchType) {
    if ([BIO_SEARCH_TYPE.sequence, BIO_SEARCH_TYPE.short].includes(searchType) && dbType === 'ALL') {
        return {
            automatic: true,
        };
    }
    if (algorithmSettings.automatic) {
        return {
            automatic: true,
        };
    }
    const params = _.transform(
        algorithmSettings,
        (r, v, k) => {
            if (!_.isNull(v)) {
                r[k] = v;
            }
        },
        {},
    );

    const processParams = _.mapKeys(params, (v, k) => _.snakeCase(k));

    if (sequenceType === ABST_NUC
        && dbType === ABST_NUC) {
        delete processParams.matrix;
    } else {
        delete processParams.match_scores;
    }

    return processParams;
}

function getBlastParam(currentSetting) {
    const subject_length = _.get(currentSetting, 'subject_length', { start: 0 });
    const multi_subject_length = _.get(currentSetting, 'multi_subject_length', { protein: { start: 0 }, nucleotide: { start: 0 } });

    return Object.assign({
        perc_identity: _.get(currentSetting, 'perc_identity'),
        qcov_hsp_perc: _.get(currentSetting, 'qcov_hsp_perc', { start: 0, end: 100 }),
        q_perc_identity: _.get(currentSetting, 'q_perc_identity', { start: 0, end: 100 }),
        s_perc_identity: _.get(currentSetting, 's_perc_identity', { start: 0, end: 100 }),
        scov_hsp_perc: _.get(currentSetting, 'scov_hsp_perc', { start: 0, end: 100 }),
    }, currentSetting.dbType === 'ALL' ? {
        multi_subject_length: {
            protein: Object.assign({ start: multi_subject_length.protein.start }, multi_subject_length.protein.end && { end: multi_subject_length.protein.end }),
            nucleotide: Object.assign({ start: multi_subject_length.nucleotide.start }, multi_subject_length.nucleotide.end && { end: multi_subject_length.nucleotide.end }),
        },
    } : { subject_length: Object.assign({ start: subject_length.start }, subject_length.end && { end: subject_length.end }) });
}

function getModificationSearchParam(currentSetting) {
    const algorithmType = _.get(currentSetting, 'algorithm_type');
    if (algorithmType === 'Blast') {
        return {
            // Blast算法，同BIO_SEARCH_TYPE.sequence
            ...transformBaseBlastParams(currentSetting, BIO_SEARCH_TYPE.modification),
            ...getBlastParam(currentSetting),
            ungapped: _.get(currentSetting, 'ungapped'),
            evalue: _.get(currentSetting, 'evalue'),
            low_complexity_region: _.get(currentSetting, 'low_complexity_region', false),
        };
    }
    // todo 非blast算法参数
    return {};
}

/**
 * 组装setting参数
 * @param {查询类型} searchType
 * @param {目标设置类型} targetSetting
 * @returns
 */
export function generateSetting(searchType, targetSetting) {
    let settings;
    switch (searchType) {
        case BIO_SEARCH_TYPE.sequence:
        case BIO_SEARCH_TYPE.degenerate:
        case BIO_SEARCH_TYPE.short:
        case BIO_SEARCH_TYPE.combined:
            settings = {
                ...transformBaseBlastParams(targetSetting, searchType),
                ...getBlastParam(targetSetting),
                // 根据不同的类型有不同的设置项
                ungapped: _.get(targetSetting, 'ungapped'),
                evalue: _.get(targetSetting, 'evalue'),
                low_complexity_region: _.get(targetSetting, 'low_complexity_region'),
            };
            break;
        case BIO_SEARCH_TYPE.cdr:
            settings = {
                automatic: true,
            };
            break;
        case BIO_SEARCH_TYPE.motif:
            settings = {
                ...getBlastParam(targetSetting),
                evalue: _.get(targetSetting, 'evalue'),
            };
            break;
        case BIO_SEARCH_TYPE.motif2:
            settings = {
                automatic: true,
                scov_hsp_perc: _.get(targetSetting, 'scov_hsp_perc'),
                subject_length: _.get(targetSetting, 'subject_length'),
            };
            break;
        case BIO_SEARCH_TYPE.antibody:
            settings = {
                ...getBlastParam(targetSetting),
                // 根据不同的类型有不同的设置项
                ungapped: _.get(targetSetting, 'ungapped'),
                evalue: _.get(targetSetting, 'evalue'),
            };
            break;
        case BIO_SEARCH_TYPE.fragmentSize:
        case BIO_SEARCH_TYPE.fragmentMulti:
            settings = {
                ...transformBaseBlastParams(targetSetting),
                ...getBlastParam(targetSetting),
                // 根据不同的类型有不同的设置项
                ungapped: _.get(targetSetting, 'ungapped'),
                evalue: _.get(targetSetting, 'evalue'),
            };
            break;
        case BIO_SEARCH_TYPE.modification:
            settings = getModificationSearchParam(targetSetting);
            break;
    }
    return settings;
}

/**
 * 计算覆盖率
 * @param {string} seq Sequence string
 * @param {Array} allowBases 有效字符
 */
const countDna = (seq, allowBases = ['A', 'T', 'G', 'U', 'C', 'R', 'Y', 'N']) => {
    const totalDnaBases = seq
        .split('')
        .reduce((count, sq) => count + (allowBases.indexOf(sq.toUpperCase()) === -1 ? 0 : 1), 0);
    const dnaFraction = totalDnaBases / seq.length;
    return dnaFraction * 100;
};

/**
 * 判断 Sequence 为核酸还是蛋白质
 * @param {string} seq Sequence string
 * @param {Number} minimum 有效字符大于90%为核酸, 小于90%为蛋白质
 */
const isDna = (seq, minimum = 90) => countDna(seq) > minimum;

export const checkSequenceType = (sequence) => {
    if (!sequence || !sequence.length) {
        return '';
    }
    return isDna(sequence) ? ABST_NUC : ABST_PROTEIN;
};

export const whitespaceRegexp = /\s/g;
const seqValidReg = /^[a-zA-Z]+$/;
const seqExtractRegexp = />[^>]*/g;
export const removeWhitespace = (value) => (value || '').replace(whitespaceRegexp, '');

export const isValidSequence = (value) => {
    return seqValidReg.test(value);
};

// 解析序列
export const parseSequence = (input, type) => {
    const sequences = [];
    if (input.indexOf('>') < 0) {
        let sequence;
        sequence = removeWhitespace(_.toUpper(input));
        if (type === 'origin') {
            sequence = input;
        }
        if (sequence) {
            sequences.push({
                label: '',
                sequence,
            });
        }
    } else {
        let match;

        // eslint-disable-next-line
        while ((match = seqExtractRegexp.exec(input)) !== null) {
            const string = match[0];
            const index = string.indexOf('\n');
            let label = '';
            let seq = '';

            if (index > -1) {
                label = string.slice(1, index);
                seq = string.slice(index + 1);
            } else {
                label = string.slice(1);
            }
            let sequence = '';
            sequence = removeWhitespace(_.toUpper(seq));
            if (type === 'origin') {
                sequence = seq;
            }
            sequences.push({
                label: _.trim(label),
                sequence,
            });
        }
    }
    return sequences.map(v => ({
        ...v,
        type: checkSequenceType(v.sequence),
        valid: isValidSequence(v.sequence),
    }));
};

export const getSequenceUnitByType = (length, type) => {
    if (!length || !type) {
        return '';
    }
    if (type === SEQUENCE_TYPE.protein.value) {
        return `${length} ${SEQUENCE_TYPE.protein.suffix}`;
    }
    return `${length} ${SEQUENCE_TYPE.nucleotide.suffix}`;
};
